module.exports = __webpack_public_path__ + "static/media/2020.8.17手绘复古伞活动.50263d5f.jpg";